import superagent from 'superagent'

export const photosSet = photos => ({
  type: 'PHOTOS_SET',
  payload: photos
})

export const photoGet = photo => ({
  type: 'PHOTO_GET',
  payload: photo
})

export const photoCreate = photo => ({
  type: 'PHOTO_CREATE',
  payload: photo
})

export const photoUpdate = photo => ({
  type: 'PHOTO_UPDATE',
  payload: photo
})

export const photoDelete = id => ({
  type: 'PHOTO_DELETE',
  payload: id
})

export const photoCreateRequest = data => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      method: 'POST',
      url: `${__API_URI__}/photo/upload`,
      headers: {
        Authorization: `Bearer ${token}`,
        Platform: 'Web',
        Version: `${__version__}`
      },
      data: data,
      processData: false,
      contentType: false,
      cache: false
    })
      .done(res => {
        Countly.q.push([
          'add_event',
          {
            key: 'Add Photo',
            count: 1,
            segmentation: {
              'Action Type': 'Upload Photo'
            }
          }
        ])
        if (res.typeId !== 1) return resolve(res)
        dispatch(photoCreate(res))
        resolve(res)
        return
      })
      .fail(data => {
        reject(data)
        return
      })
  })
}

export const photoUploadRequest = data => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      method: 'POST',
      url: `${__API_URI__}/photo/upload?activity=1`,
      headers: {
        Authorization: `Bearer ${token}`,
        Platform: 'Web',
        Version: `${__version__}`
      },
      data: data,
      processData: false,
      contentType: false,
      cache: false
    })
      .done(res => {
        resolve(res)
      })
      .fail(data => {
        reject(data)
      })
  })
}

export const photoGetRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/photo/get/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err.status)
          return
        }
        resolve(res.body)
        dispatch(photoGet(res.body))
        return res.body
      })
  })
}

export const photoFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/photo/GetByActivity?actvityId=1`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(photosSet(res.body))
        return res.body
      })
  })
}

export const photoUpdateRequest = photoObj => (dispatch, getState, token) => {
  //let auth = getState().auth.token
  return new Promise(resolve => {
    superagent
      .put(`${__API_URI__}/photo/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(photoObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(photoUpdate(res.body))
        return res.body
      })
  })
}

export const photoDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/photo/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
          return reject(err)
        }
        dispatch(photosSet(getState().photos.filter(photo => photo.id !== id)))
        resolve()
      })
  })
}

export const photoGetAjax = photoId => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      method: 'GET',
      url: `${__API_URI__}/photo/get/${photoId}`,
      headers: {
        Authorization: `Bearer ${token}`,
        Platform: 'Web',
        Version: `${__version__}`
      }
    })
      .done(res => {
        resolve(res)
        dispatch(photoGet(res))
      })
      .fail(err => {
        reject(err)
      })
  })
}
